import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  IAttendant,
  IEventAndSessionData,
} from "../../interfaces/reports.interfaces";
import { AssistanceService } from "src/app/attendanceRecord/services/asistanceService/assistance.service";
import { originDataEnumEmailPerAd } from "src/app/attendanceRecord/constants/idOriginAsistance";
@Component({
  selector: "app-attendance-parts-detail",
  templateUrl: "./attendance-parts-detail.component.html",
  styleUrls: ["./attendance-parts-detail.component.css"],
})
export class AttendancePartsDetailComponent {
  @Input()
  public attendant?: IAttendant;
  @Input()
  public totalPartsNumber?: number;
  @Input()
  public eventAndSessionData?: IEventAndSessionData;
  @Output()
  public closeOffCanvasEmitter: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  public selectedParts: number[] = [];
  constructor(private assistanceService: AssistanceService) {}

  get attendanceParts() {
    return this.attendant?.fechasInicioSesion || [];
  }

  get attendantFullName() {
    return `${this.attendant?.nombre ?? ""} ${
      this.attendant?.segundoNombre ?? ""
    } ${this.attendant?.apellidoPaterno ?? ""} ${
      this.attendant?.apellidoMaterno ?? ""
    }`;
  }
  get canShowControls(): boolean {
    return (this.totalPartsNumber ?? 0) >= 2 && this.attendanceParts.length > 0;
  }

  isPartSelected(part: number): boolean {
    return this.selectedParts.includes(part);
  }

  onTogglePart(part: number) {
    this.selectedParts = this.selectedParts.includes(part)
      ? this.selectedParts.filter(p => p !== part)
      : [...this.selectedParts, part];
  }

  async registerMissingAttendances() {
    if (!this.selectedParts.length || !this.attendant) {
      return;
    }
    const { fkIdSesion, numeroPersona } = this.attendant;

    for (const part of this.selectedParts) {
      await new Promise<void>(resolve => {
        this.assistanceService
          .postAssistanceUserNotFoundV2(
            {
              fkIdSesion,
              numeroSesion: part,
              fkIdOrigen: originDataEnumEmailPerAd.personNumber,
            },
            { personNumber: numeroPersona }
          )
          .subscribe({
            next: () => {
              if (this.attendant) {
                this.attendant = {
                  ...this.attendant,
                  fechasInicioSesion: [
                    ...(this.attendant.fechasInicioSesion || []),
                    { parte: part, fechaRegistro: new Date() },
                  ],
                };
              }
              resolve();
            },
            error: () => resolve(),
          });
      });
    }
    this.finishProcess();
  }
  finishProcess() {
    this.selectedParts = [];
    this.closeOffCanvasEmitter.emit(true);
  }
  getAttendanceDateForPart(partNumber: number): string | null {
    const match = this.attendanceParts.find(p => p.parte === partNumber);
    return match?.fechaRegistro
      ? new Date(match.fechaRegistro).toLocaleDateString("es-MX")
      : null;
  }

  hasAttendance(partNumber: number): boolean {
    return this.attendanceParts.some(p => p.parte === partNumber);
  }

  onClose() {
    this.attendant = undefined;
    this.totalPartsNumber = undefined;
    this.eventAndSessionData = undefined;
    this.closeOffCanvasEmitter.emit(true);
  }
}
